import { FetchBaseQueryError } from '@reduxjs/toolkit/query'

export function isFetchBaseQueryError(
  error: unknown
): error is FetchBaseQueryError {
  return typeof error === 'object' && error !== null && 'status' in error
}

export function getErrorDescription(error: unknown): string {
  let description = 'An unknown error occurred.'
  if (error) {
    if (isFetchBaseQueryError(error)) {
      if ('data' in error) {
        if (typeof error.data === 'string') {
          description = error.data
        } else if (
          typeof error.data === 'object' &&
          error.data !== null &&
          'message' in error.data
        ) {
          description =
            (error.data as { message?: string }).message || description
        }
      }
    } else if (
      typeof error === 'object' &&
      error !== null &&
      'message' in error &&
      typeof (error as { message?: unknown }).message === 'string'
    ) {
      description = (error as { message: string }).message
    }
  }
  return description
}
